var map = {
	"./AppLogo.vue": "./resources/icons/AppLogo.vue",
	"./FileProcessingIllustration.vue": "./resources/icons/FileProcessingIllustration.vue",
	"./IconAccess.vue": "./resources/icons/IconAccess.vue",
	"./IconAccessDetails.vue": "./resources/icons/IconAccessDetails.vue",
	"./IconActivityAvatarLoading.vue": "./resources/icons/IconActivityAvatarLoading.vue",
	"./IconActivityDetails.vue": "./resources/icons/IconActivityDetails.vue",
	"./IconAddPerson.vue": "./resources/icons/IconAddPerson.vue",
	"./IconAnalytics.vue": "./resources/icons/IconAnalytics.vue",
	"./IconAppearance.vue": "./resources/icons/IconAppearance.vue",
	"./IconArrowBoth.vue": "./resources/icons/IconArrowBoth.vue",
	"./IconArrowDown.vue": "./resources/icons/IconArrowDown.vue",
	"./IconArrowLeftSm.vue": "./resources/icons/IconArrowLeftSm.vue",
	"./IconArrowRight.vue": "./resources/icons/IconArrowRight.vue",
	"./IconArrowRightAlt.vue": "./resources/icons/IconArrowRightAlt.vue",
	"./IconArrowRightLight.vue": "./resources/icons/IconArrowRightLight.vue",
	"./IconArrowRightSm.vue": "./resources/icons/IconArrowRightSm.vue",
	"./IconArrowRightSmall.vue": "./resources/icons/IconArrowRightSmall.vue",
	"./IconArrowUpDown.vue": "./resources/icons/IconArrowUpDown.vue",
	"./IconAttachments.vue": "./resources/icons/IconAttachments.vue",
	"./IconAudienceAvgPlays.vue": "./resources/icons/IconAudienceAvgPlays.vue",
	"./IconAudienceFinishes.vue": "./resources/icons/IconAudienceFinishes.vue",
	"./IconAudiencePlays.vue": "./resources/icons/IconAudiencePlays.vue",
	"./IconAudienceProfileLoading.vue": "./resources/icons/IconAudienceProfileLoading.vue",
	"./IconAudienceSearch.vue": "./resources/icons/IconAudienceSearch.vue",
	"./IconAudienceThumbsUp.vue": "./resources/icons/IconAudienceThumbsUp.vue",
	"./IconAudienceView.vue": "./resources/icons/IconAudienceView.vue",
	"./IconAudio.vue": "./resources/icons/IconAudio.vue",
	"./IconAudioSettings.vue": "./resources/icons/IconAudioSettings.vue",
	"./IconAutoAdd.vue": "./resources/icons/IconAutoAdd.vue",
	"./IconAutoProcess.vue": "./resources/icons/IconAutoProcess.vue",
	"./IconBack.vue": "./resources/icons/IconBack.vue",
	"./IconBackArrow.vue": "./resources/icons/IconBackArrow.vue",
	"./IconBilling.vue": "./resources/icons/IconBilling.vue",
	"./IconBreadcrumb.vue": "./resources/icons/IconBreadcrumb.vue",
	"./IconBrowser.vue": "./resources/icons/IconBrowser.vue",
	"./IconCalendar.vue": "./resources/icons/IconCalendar.vue",
	"./IconCalendarBig.vue": "./resources/icons/IconCalendarBig.vue",
	"./IconCaption.vue": "./resources/icons/IconCaption.vue",
	"./IconCard.vue": "./resources/icons/IconCard.vue",
	"./IconCardAmex.vue": "./resources/icons/IconCardAmex.vue",
	"./IconCardDiners.vue": "./resources/icons/IconCardDiners.vue",
	"./IconCardDiscover.vue": "./resources/icons/IconCardDiscover.vue",
	"./IconCardJcb.vue": "./resources/icons/IconCardJcb.vue",
	"./IconCardMastercard.vue": "./resources/icons/IconCardMastercard.vue",
	"./IconCardVisa.vue": "./resources/icons/IconCardVisa.vue",
	"./IconChapterSmall.vue": "./resources/icons/IconChapterSmall.vue",
	"./IconChapters.vue": "./resources/icons/IconChapters.vue",
	"./IconChart.vue": "./resources/icons/IconChart.vue",
	"./IconCheck.vue": "./resources/icons/IconCheck.vue",
	"./IconCheckSmall.vue": "./resources/icons/IconCheckSmall.vue",
	"./IconClock.vue": "./resources/icons/IconClock.vue",
	"./IconClose.vue": "./resources/icons/IconClose.vue",
	"./IconCloseCircle.vue": "./resources/icons/IconCloseCircle.vue",
	"./IconCloseCircleLg.vue": "./resources/icons/IconCloseCircleLg.vue",
	"./IconCloseLg.vue": "./resources/icons/IconCloseLg.vue",
	"./IconCloseModal.vue": "./resources/icons/IconCloseModal.vue",
	"./IconCloud.vue": "./resources/icons/IconCloud.vue",
	"./IconCloudSync.vue": "./resources/icons/IconCloudSync.vue",
	"./IconCloudup.vue": "./resources/icons/IconCloudup.vue",
	"./IconCoin.vue": "./resources/icons/IconCoin.vue",
	"./IconCollapse.vue": "./resources/icons/IconCollapse.vue",
	"./IconColumn.vue": "./resources/icons/IconColumn.vue",
	"./IconColumnCenter.vue": "./resources/icons/IconColumnCenter.vue",
	"./IconColumnLeft.vue": "./resources/icons/IconColumnLeft.vue",
	"./IconColumnRight.vue": "./resources/icons/IconColumnRight.vue",
	"./IconComputer.vue": "./resources/icons/IconComputer.vue",
	"./IconCopy.vue": "./resources/icons/IconCopy.vue",
	"./IconCss.vue": "./resources/icons/IconCss.vue",
	"./IconCustomDates.vue": "./resources/icons/IconCustomDates.vue",
	"./IconCustomize.vue": "./resources/icons/IconCustomize.vue",
	"./IconCustomizeMenus.vue": "./resources/icons/IconCustomizeMenus.vue",
	"./IconDay.vue": "./resources/icons/IconDay.vue",
	"./IconDelete.vue": "./resources/icons/IconDelete.vue",
	"./IconDeleteAudience.vue": "./resources/icons/IconDeleteAudience.vue",
	"./IconDeleteLg.vue": "./resources/icons/IconDeleteLg.vue",
	"./IconDesktop.vue": "./resources/icons/IconDesktop.vue",
	"./IconDevices.vue": "./resources/icons/IconDevices.vue",
	"./IconDoc.vue": "./resources/icons/IconDoc.vue",
	"./IconDocPdf.vue": "./resources/icons/IconDocPdf.vue",
	"./IconDomainEmbed.vue": "./resources/icons/IconDomainEmbed.vue",
	"./IconDots.vue": "./resources/icons/IconDots.vue",
	"./IconDownload.vue": "./resources/icons/IconDownload.vue",
	"./IconDrag.vue": "./resources/icons/IconDrag.vue",
	"./IconDraggable.vue": "./resources/icons/IconDraggable.vue",
	"./IconDropArrow.vue": "./resources/icons/IconDropArrow.vue",
	"./IconDropbox.vue": "./resources/icons/IconDropbox.vue",
	"./IconDuplicate.vue": "./resources/icons/IconDuplicate.vue",
	"./IconDurationLong.vue": "./resources/icons/IconDurationLong.vue",
	"./IconDurationShort.vue": "./resources/icons/IconDurationShort.vue",
	"./IconEdit.vue": "./resources/icons/IconEdit.vue",
	"./IconEditScript.vue": "./resources/icons/IconEditScript.vue",
	"./IconEditTranscript.vue": "./resources/icons/IconEditTranscript.vue",
	"./IconElementButton.vue": "./resources/icons/IconElementButton.vue",
	"./IconElementHeadline.vue": "./resources/icons/IconElementHeadline.vue",
	"./IconElementImage.vue": "./resources/icons/IconElementImage.vue",
	"./IconElementLinebreak.vue": "./resources/icons/IconElementLinebreak.vue",
	"./IconElementParagraph.vue": "./resources/icons/IconElementParagraph.vue",
	"./IconElementSubheadline.vue": "./resources/icons/IconElementSubheadline.vue",
	"./IconElementText.vue": "./resources/icons/IconElementText.vue",
	"./IconElementVideo.vue": "./resources/icons/IconElementVideo.vue",
	"./IconEllipse.vue": "./resources/icons/IconEllipse.vue",
	"./IconEmail.vue": "./resources/icons/IconEmail.vue",
	"./IconEmbed.vue": "./resources/icons/IconEmbed.vue",
	"./IconEmbedAudio.vue": "./resources/icons/IconEmbedAudio.vue",
	"./IconEmbedVideo.vue": "./resources/icons/IconEmbedVideo.vue",
	"./IconEmptyAudience.vue": "./resources/icons/IconEmptyAudience.vue",
	"./IconExit.vue": "./resources/icons/IconExit.vue",
	"./IconExport.vue": "./resources/icons/IconExport.vue",
	"./IconExtension.vue": "./resources/icons/IconExtension.vue",
	"./IconEyedropper.vue": "./resources/icons/IconEyedropper.vue",
	"./IconFacebook.vue": "./resources/icons/IconFacebook.vue",
	"./IconFacebookNotf.vue": "./resources/icons/IconFacebookNotf.vue",
	"./IconFailed.vue": "./resources/icons/IconFailed.vue",
	"./IconFeed.vue": "./resources/icons/IconFeed.vue",
	"./IconFile.vue": "./resources/icons/IconFile.vue",
	"./IconFileExplorerImage.vue": "./resources/icons/IconFileExplorerImage.vue",
	"./IconFileExplorerPdf.vue": "./resources/icons/IconFileExplorerPdf.vue",
	"./IconFileExplorerSearch.vue": "./resources/icons/IconFileExplorerSearch.vue",
	"./IconFiles.vue": "./resources/icons/IconFiles.vue",
	"./IconFilter.vue": "./resources/icons/IconFilter.vue",
	"./IconFilters.vue": "./resources/icons/IconFilters.vue",
	"./IconFolder.vue": "./resources/icons/IconFolder.vue",
	"./IconFolderSmall.vue": "./resources/icons/IconFolderSmall.vue",
	"./IconFolderlg.vue": "./resources/icons/IconFolderlg.vue",
	"./IconForward.vue": "./resources/icons/IconForward.vue",
	"./IconFullscreen.vue": "./resources/icons/IconFullscreen.vue",
	"./IconGlobe.vue": "./resources/icons/IconGlobe.vue",
	"./IconGoogle.vue": "./resources/icons/IconGoogle.vue",
	"./IconGoogleDrive.vue": "./resources/icons/IconGoogleDrive.vue",
	"./IconGooglePodcast.vue": "./resources/icons/IconGooglePodcast.vue",
	"./IconGraph.vue": "./resources/icons/IconGraph.vue",
	"./IconGroup.vue": "./resources/icons/IconGroup.vue",
	"./IconHelp.vue": "./resources/icons/IconHelp.vue",
	"./IconHide.vue": "./resources/icons/IconHide.vue",
	"./IconHistory.vue": "./resources/icons/IconHistory.vue",
	"./IconHubs.vue": "./resources/icons/IconHubs.vue",
	"./IconHubsCancel.vue": "./resources/icons/IconHubsCancel.vue",
	"./IconHubsTime.vue": "./resources/icons/IconHubsTime.vue",
	"./IconHubsWarning.vue": "./resources/icons/IconHubsWarning.vue",
	"./IconImage.vue": "./resources/icons/IconImage.vue",
	"./IconImpersonate.vue": "./resources/icons/IconImpersonate.vue",
	"./IconImport.vue": "./resources/icons/IconImport.vue",
	"./IconInfo.vue": "./resources/icons/IconInfo.vue",
	"./IconIntegrate.vue": "./resources/icons/IconIntegrate.vue",
	"./IconInterface.vue": "./resources/icons/IconInterface.vue",
	"./IconKey.vue": "./resources/icons/IconKey.vue",
	"./IconKeywords.vue": "./resources/icons/IconKeywords.vue",
	"./IconLabelling.vue": "./resources/icons/IconLabelling.vue",
	"./IconLandscape.vue": "./resources/icons/IconLandscape.vue",
	"./IconLastMonthDate.vue": "./resources/icons/IconLastMonthDate.vue",
	"./IconLastWeekDate.vue": "./resources/icons/IconLastWeekDate.vue",
	"./IconLastYearDate.vue": "./resources/icons/IconLastYearDate.vue",
	"./IconLibrary.vue": "./resources/icons/IconLibrary.vue",
	"./IconLink.vue": "./resources/icons/IconLink.vue",
	"./IconLinkSec.vue": "./resources/icons/IconLinkSec.vue",
	"./IconList.vue": "./resources/icons/IconList.vue",
	"./IconListBullet.vue": "./resources/icons/IconListBullet.vue",
	"./IconListOrder.vue": "./resources/icons/IconListOrder.vue",
	"./IconLocal.vue": "./resources/icons/IconLocal.vue",
	"./IconLocation.vue": "./resources/icons/IconLocation.vue",
	"./IconLock.vue": "./resources/icons/IconLock.vue",
	"./IconLogo.vue": "./resources/icons/IconLogo.vue",
	"./IconLogoSearchieCopilot.vue": "./resources/icons/IconLogoSearchieCopilot.vue",
	"./IconLoop.vue": "./resources/icons/IconLoop.vue",
	"./IconMediaAdd.vue": "./resources/icons/IconMediaAdd.vue",
	"./IconMediaPlay.vue": "./resources/icons/IconMediaPlay.vue",
	"./IconMediaTags.vue": "./resources/icons/IconMediaTags.vue",
	"./IconMenu.vue": "./resources/icons/IconMenu.vue",
	"./IconMenuAnalytics.vue": "./resources/icons/IconMenuAnalytics.vue",
	"./IconMenuAudience.vue": "./resources/icons/IconMenuAudience.vue",
	"./IconMenuFolders.vue": "./resources/icons/IconMenuFolders.vue",
	"./IconMenuHubs.vue": "./resources/icons/IconMenuHubs.vue",
	"./IconMenuMedia.vue": "./resources/icons/IconMenuMedia.vue",
	"./IconMenuPlaylists.vue": "./resources/icons/IconMenuPlaylists.vue",
	"./IconMenuRewards.vue": "./resources/icons/IconMenuRewards.vue",
	"./IconMenuWidgets.vue": "./resources/icons/IconMenuWidgets.vue",
	"./IconMobile.vue": "./resources/icons/IconMobile.vue",
	"./IconMonth.vue": "./resources/icons/IconMonth.vue",
	"./IconMoon.vue": "./resources/icons/IconMoon.vue",
	"./IconMove.vue": "./resources/icons/IconMove.vue",
	"./IconMoveBottom.vue": "./resources/icons/IconMoveBottom.vue",
	"./IconMoveFile.vue": "./resources/icons/IconMoveFile.vue",
	"./IconMoveTop.vue": "./resources/icons/IconMoveTop.vue",
	"./IconNoTranscription.vue": "./resources/icons/IconNoTranscription.vue",
	"./IconNotifications.vue": "./resources/icons/IconNotifications.vue",
	"./IconOneDrive.vue": "./resources/icons/IconOneDrive.vue",
	"./IconOpen.vue": "./resources/icons/IconOpen.vue",
	"./IconOpenLg.vue": "./resources/icons/IconOpenLg.vue",
	"./IconOpenOutside.vue": "./resources/icons/IconOpenOutside.vue",
	"./IconOs.vue": "./resources/icons/IconOs.vue",
	"./IconOvercast.vue": "./resources/icons/IconOvercast.vue",
	"./IconPage.vue": "./resources/icons/IconPage.vue",
	"./IconPageLg.vue": "./resources/icons/IconPageLg.vue",
	"./IconPassword.vue": "./resources/icons/IconPassword.vue",
	"./IconPause.vue": "./resources/icons/IconPause.vue",
	"./IconPending.vue": "./resources/icons/IconPending.vue",
	"./IconPeople.vue": "./resources/icons/IconPeople.vue",
	"./IconPeopleAdd.vue": "./resources/icons/IconPeopleAdd.vue",
	"./IconPerson.vue": "./resources/icons/IconPerson.vue",
	"./IconPlPlayer.vue": "./resources/icons/IconPlPlayer.vue",
	"./IconPlay.vue": "./resources/icons/IconPlay.vue",
	"./IconPlayer.vue": "./resources/icons/IconPlayer.vue",
	"./IconPlaylistAdd.vue": "./resources/icons/IconPlaylistAdd.vue",
	"./IconPlaylistAddAlt.vue": "./resources/icons/IconPlaylistAddAlt.vue",
	"./IconPlaylistAddCta.vue": "./resources/icons/IconPlaylistAddCta.vue",
	"./IconPlaylistEdit.vue": "./resources/icons/IconPlaylistEdit.vue",
	"./IconPlaylistFeed.vue": "./resources/icons/IconPlaylistFeed.vue",
	"./IconPlaylists.vue": "./resources/icons/IconPlaylists.vue",
	"./IconPlus.vue": "./resources/icons/IconPlus.vue",
	"./IconPodcast.vue": "./resources/icons/IconPodcast.vue",
	"./IconPowerSearchieCopilot.vue": "./resources/icons/IconPowerSearchieCopilot.vue",
	"./IconProcessed.vue": "./resources/icons/IconProcessed.vue",
	"./IconProfile.vue": "./resources/icons/IconProfile.vue",
	"./IconProfileDetails.vue": "./resources/icons/IconProfileDetails.vue",
	"./IconProfileEmpty.vue": "./resources/icons/IconProfileEmpty.vue",
	"./IconProofread.vue": "./resources/icons/IconProofread.vue",
	"./IconProofreadDone.vue": "./resources/icons/IconProofreadDone.vue",
	"./IconProofreadDoneSmall.vue": "./resources/icons/IconProofreadDoneSmall.vue",
	"./IconProofreadPending.vue": "./resources/icons/IconProofreadPending.vue",
	"./IconProofreadPendingSmall.vue": "./resources/icons/IconProofreadPendingSmall.vue",
	"./IconPublic.vue": "./resources/icons/IconPublic.vue",
	"./IconPuppy.vue": "./resources/icons/IconPuppy.vue",
	"./IconQuestion.vue": "./resources/icons/IconQuestion.vue",
	"./IconQuestionCircle.vue": "./resources/icons/IconQuestionCircle.vue",
	"./IconRaw.vue": "./resources/icons/IconRaw.vue",
	"./IconRecent.vue": "./resources/icons/IconRecent.vue",
	"./IconRecord.vue": "./resources/icons/IconRecord.vue",
	"./IconRedo.vue": "./resources/icons/IconRedo.vue",
	"./IconRefresh.vue": "./resources/icons/IconRefresh.vue",
	"./IconRemove.vue": "./resources/icons/IconRemove.vue",
	"./IconRename.vue": "./resources/icons/IconRename.vue",
	"./IconReplace.vue": "./resources/icons/IconReplace.vue",
	"./IconRetry.vue": "./resources/icons/IconRetry.vue",
	"./IconRetrying.vue": "./resources/icons/IconRetrying.vue",
	"./IconRewind.vue": "./resources/icons/IconRewind.vue",
	"./IconRight.vue": "./resources/icons/IconRight.vue",
	"./IconRightCircle.vue": "./resources/icons/IconRightCircle.vue",
	"./IconSEO.vue": "./resources/icons/IconSEO.vue",
	"./IconScript.vue": "./resources/icons/IconScript.vue",
	"./IconSearch.vue": "./resources/icons/IconSearch.vue",
	"./IconSearchArrowLeft.vue": "./resources/icons/IconSearchArrowLeft.vue",
	"./IconSearchArrowRight.vue": "./resources/icons/IconSearchArrowRight.vue",
	"./IconSectionCarousel.vue": "./resources/icons/IconSectionCarousel.vue",
	"./IconSectionColumn.vue": "./resources/icons/IconSectionColumn.vue",
	"./IconSectionCompact.vue": "./resources/icons/IconSectionCompact.vue",
	"./IconSectionCompleted.vue": "./resources/icons/IconSectionCompleted.vue",
	"./IconSectionCta.vue": "./resources/icons/IconSectionCta.vue",
	"./IconSectionCtaGrid.vue": "./resources/icons/IconSectionCtaGrid.vue",
	"./IconSectionFeatured.vue": "./resources/icons/IconSectionFeatured.vue",
	"./IconSectionFooter.vue": "./resources/icons/IconSectionFooter.vue",
	"./IconSectionGrid.vue": "./resources/icons/IconSectionGrid.vue",
	"./IconSectionHeader.vue": "./resources/icons/IconSectionHeader.vue",
	"./IconSectionHero.vue": "./resources/icons/IconSectionHero.vue",
	"./IconSectionImage.vue": "./resources/icons/IconSectionImage.vue",
	"./IconSectionScroll.vue": "./resources/icons/IconSectionScroll.vue",
	"./IconSectionSearch.vue": "./resources/icons/IconSectionSearch.vue",
	"./IconSectionText.vue": "./resources/icons/IconSectionText.vue",
	"./IconSectionWatching.vue": "./resources/icons/IconSectionWatching.vue",
	"./IconSections.vue": "./resources/icons/IconSections.vue",
	"./IconSegment.vue": "./resources/icons/IconSegment.vue",
	"./IconSegmentLoad.vue": "./resources/icons/IconSegmentLoad.vue",
	"./IconSegmentSave.vue": "./resources/icons/IconSegmentSave.vue",
	"./IconSend.vue": "./resources/icons/IconSend.vue",
	"./IconSettings.vue": "./resources/icons/IconSettings.vue",
	"./IconSettingsApi.vue": "./resources/icons/IconSettingsApi.vue",
	"./IconSettingsEmbedDomains.vue": "./resources/icons/IconSettingsEmbedDomains.vue",
	"./IconSettingsInfo.vue": "./resources/icons/IconSettingsInfo.vue",
	"./IconSettingsInvoice.vue": "./resources/icons/IconSettingsInvoice.vue",
	"./IconSettingsPayment.vue": "./resources/icons/IconSettingsPayment.vue",
	"./IconSettingsPlayerSettings.vue": "./resources/icons/IconSettingsPlayerSettings.vue",
	"./IconSettingsProfile.vue": "./resources/icons/IconSettingsProfile.vue",
	"./IconSettingsProofread.vue": "./resources/icons/IconSettingsProofread.vue",
	"./IconSettingsSecurity.vue": "./resources/icons/IconSettingsSecurity.vue",
	"./IconSettingsSubscription.vue": "./resources/icons/IconSettingsSubscription.vue",
	"./IconSettingsTranscriptions.vue": "./resources/icons/IconSettingsTranscriptions.vue",
	"./IconShare.vue": "./resources/icons/IconShare.vue",
	"./IconSortAlphabetical.vue": "./resources/icons/IconSortAlphabetical.vue",
	"./IconSortAplphabeticalReverse.vue": "./resources/icons/IconSortAplphabeticalReverse.vue",
	"./IconSortAsc.vue": "./resources/icons/IconSortAsc.vue",
	"./IconSortDesc.vue": "./resources/icons/IconSortDesc.vue",
	"./IconStatsAveragePlay.vue": "./resources/icons/IconStatsAveragePlay.vue",
	"./IconStatsDetails.vue": "./resources/icons/IconStatsDetails.vue",
	"./IconStatsEmpty.vue": "./resources/icons/IconStatsEmpty.vue",
	"./IconStatsFinish.vue": "./resources/icons/IconStatsFinish.vue",
	"./IconStatsPlay.vue": "./resources/icons/IconStatsPlay.vue",
	"./IconStatsSearch.vue": "./resources/icons/IconStatsSearch.vue",
	"./IconStatsVisit.vue": "./resources/icons/IconStatsVisit.vue",
	"./IconStorage.vue": "./resources/icons/IconStorage.vue",
	"./IconStripe.vue": "./resources/icons/IconStripe.vue",
	"./IconSync.vue": "./resources/icons/IconSync.vue",
	"./IconTag.vue": "./resources/icons/IconTag.vue",
	"./IconTagLg.vue": "./resources/icons/IconTagLg.vue",
	"./IconTags.vue": "./resources/icons/IconTags.vue",
	"./IconTarget.vue": "./resources/icons/IconTarget.vue",
	"./IconTelephone.vue": "./resources/icons/IconTelephone.vue",
	"./IconTextBackground.vue": "./resources/icons/IconTextBackground.vue",
	"./IconTextBold.vue": "./resources/icons/IconTextBold.vue",
	"./IconTextCenter.vue": "./resources/icons/IconTextCenter.vue",
	"./IconTextFile.vue": "./resources/icons/IconTextFile.vue",
	"./IconTextFont.vue": "./resources/icons/IconTextFont.vue",
	"./IconTextItalic.vue": "./resources/icons/IconTextItalic.vue",
	"./IconTextLeft.vue": "./resources/icons/IconTextLeft.vue",
	"./IconTextLink.vue": "./resources/icons/IconTextLink.vue",
	"./IconTextRight.vue": "./resources/icons/IconTextRight.vue",
	"./IconTextStriketrough.vue": "./resources/icons/IconTextStriketrough.vue",
	"./IconTextUnderline.vue": "./resources/icons/IconTextUnderline.vue",
	"./IconTheme.vue": "./resources/icons/IconTheme.vue",
	"./IconThumbsDown.vue": "./resources/icons/IconThumbsDown.vue",
	"./IconThumbsUp.vue": "./resources/icons/IconThumbsUp.vue",
	"./IconTick.vue": "./resources/icons/IconTick.vue",
	"./IconTimeline.vue": "./resources/icons/IconTimeline.vue",
	"./IconTodayDate.vue": "./resources/icons/IconTodayDate.vue",
	"./IconTracking.vue": "./resources/icons/IconTracking.vue",
	"./IconTranscriptionFailed.vue": "./resources/icons/IconTranscriptionFailed.vue",
	"./IconTranscriptionPending.vue": "./resources/icons/IconTranscriptionPending.vue",
	"./IconTypography.vue": "./resources/icons/IconTypography.vue",
	"./IconUndo.vue": "./resources/icons/IconUndo.vue",
	"./IconUpdates.vue": "./resources/icons/IconUpdates.vue",
	"./IconUpload.vue": "./resources/icons/IconUpload.vue",
	"./IconUploadBig.vue": "./resources/icons/IconUploadBig.vue",
	"./IconUploadLg.vue": "./resources/icons/IconUploadLg.vue",
	"./IconUploadSimple.vue": "./resources/icons/IconUploadSimple.vue",
	"./IconUser.vue": "./resources/icons/IconUser.vue",
	"./IconVideo.vue": "./resources/icons/IconVideo.vue",
	"./IconVideoSm.vue": "./resources/icons/IconVideoSm.vue",
	"./IconViewGrid.vue": "./resources/icons/IconViewGrid.vue",
	"./IconViewList.vue": "./resources/icons/IconViewList.vue",
	"./IconVimeo.vue": "./resources/icons/IconVimeo.vue",
	"./IconVimeoPlus.vue": "./resources/icons/IconVimeoPlus.vue",
	"./IconVisit.vue": "./resources/icons/IconVisit.vue",
	"./IconVisitor.vue": "./resources/icons/IconVisitor.vue",
	"./IconVocab.vue": "./resources/icons/IconVocab.vue",
	"./IconVolume.vue": "./resources/icons/IconVolume.vue",
	"./IconWarning.vue": "./resources/icons/IconWarning.vue",
	"./IconWarningSmall.vue": "./resources/icons/IconWarningSmall.vue",
	"./IconWeek.vue": "./resources/icons/IconWeek.vue",
	"./IconWidget.vue": "./resources/icons/IconWidget.vue",
	"./IconWidgetFull.vue": "./resources/icons/IconWidgetFull.vue",
	"./IconWidgetPopup.vue": "./resources/icons/IconWidgetPopup.vue",
	"./IconWidgetSmall.vue": "./resources/icons/IconWidgetSmall.vue",
	"./IconWistia.vue": "./resources/icons/IconWistia.vue",
	"./IconYear.vue": "./resources/icons/IconYear.vue",
	"./IconYesterdayDate.vue": "./resources/icons/IconYesterdayDate.vue",
	"./IconYoutube.vue": "./resources/icons/IconYoutube.vue",
	"./IconZapier.vue": "./resources/icons/IconZapier.vue",
	"./IconZoom.vue": "./resources/icons/IconZoom.vue",
	"./IconsVideo.vue": "./resources/icons/IconsVideo.vue",
	"./Languages/ar-AE.vue": "./resources/icons/Languages/ar-AE.vue",
	"./Languages/ar-SA.vue": "./resources/icons/Languages/ar-SA.vue",
	"./Languages/de-CH.vue": "./resources/icons/Languages/de-CH.vue",
	"./Languages/de-DE.vue": "./resources/icons/Languages/de-DE.vue",
	"./Languages/en-AB.vue": "./resources/icons/Languages/en-AB.vue",
	"./Languages/en-AU.vue": "./resources/icons/Languages/en-AU.vue",
	"./Languages/en-GB.vue": "./resources/icons/Languages/en-GB.vue",
	"./Languages/en-IE.vue": "./resources/icons/Languages/en-IE.vue",
	"./Languages/en-IN.vue": "./resources/icons/Languages/en-IN.vue",
	"./Languages/en-US.vue": "./resources/icons/Languages/en-US.vue",
	"./Languages/en-WL.vue": "./resources/icons/Languages/en-WL.vue",
	"./Languages/es-ES.vue": "./resources/icons/Languages/es-ES.vue",
	"./Languages/es-US.vue": "./resources/icons/Languages/es-US.vue",
	"./Languages/fa-IR.vue": "./resources/icons/Languages/fa-IR.vue",
	"./Languages/fr-CA.vue": "./resources/icons/Languages/fr-CA.vue",
	"./Languages/fr-FR.vue": "./resources/icons/Languages/fr-FR.vue",
	"./Languages/he-IL.vue": "./resources/icons/Languages/he-IL.vue",
	"./Languages/hi-IN.vue": "./resources/icons/Languages/hi-IN.vue",
	"./Languages/id-ID.vue": "./resources/icons/Languages/id-ID.vue",
	"./Languages/it-IT.vue": "./resources/icons/Languages/it-IT.vue",
	"./Languages/ja-JP.vue": "./resources/icons/Languages/ja-JP.vue",
	"./Languages/ko-KR.vue": "./resources/icons/Languages/ko-KR.vue",
	"./Languages/ms-MY.vue": "./resources/icons/Languages/ms-MY.vue",
	"./Languages/nl-NL.vue": "./resources/icons/Languages/nl-NL.vue",
	"./Languages/pt-BR.vue": "./resources/icons/Languages/pt-BR.vue",
	"./Languages/pt-PT.vue": "./resources/icons/Languages/pt-PT.vue",
	"./Languages/ru-RU.vue": "./resources/icons/Languages/ru-RU.vue",
	"./Languages/ta-IN.vue": "./resources/icons/Languages/ta-IN.vue",
	"./Languages/te-IN.vue": "./resources/icons/Languages/te-IN.vue",
	"./Languages/tr-TR.vue": "./resources/icons/Languages/tr-TR.vue",
	"./Languages/zh-CN.vue": "./resources/icons/Languages/zh-CN.vue",
	"./MediaSnapshotFinishes.vue": "./resources/icons/MediaSnapshotFinishes.vue",
	"./MediaSnapshotPlays.vue": "./resources/icons/MediaSnapshotPlays.vue",
	"./MediaSnapshotSearches.vue": "./resources/icons/MediaSnapshotSearches.vue",
	"./MediaSnapshotVisits.vue": "./resources/icons/MediaSnapshotVisits.vue",
	"./Player/ErrorDefault.vue": "./resources/icons/Player/ErrorDefault.vue",
	"./Player/ErrorNotFound.vue": "./resources/icons/Player/ErrorNotFound.vue",
	"./Player/ErrorProcessing.vue": "./resources/icons/Player/ErrorProcessing.vue",
	"./Player/ErrorUnauthorized.vue": "./resources/icons/Player/ErrorUnauthorized.vue",
	"./PopupButtonPositions/IconLeftBottom1.vue": "./resources/icons/PopupButtonPositions/IconLeftBottom1.vue",
	"./PopupButtonPositions/IconLeftBottom2.vue": "./resources/icons/PopupButtonPositions/IconLeftBottom2.vue",
	"./PopupButtonPositions/IconLeftBottom3.vue": "./resources/icons/PopupButtonPositions/IconLeftBottom3.vue",
	"./PopupButtonPositions/IconLeftMiddle.vue": "./resources/icons/PopupButtonPositions/IconLeftMiddle.vue",
	"./PopupButtonPositions/IconLeftTop1.vue": "./resources/icons/PopupButtonPositions/IconLeftTop1.vue",
	"./PopupButtonPositions/IconLeftTop2.vue": "./resources/icons/PopupButtonPositions/IconLeftTop2.vue",
	"./PopupButtonPositions/IconLeftTop3.vue": "./resources/icons/PopupButtonPositions/IconLeftTop3.vue",
	"./PopupButtonPositions/IconMiddleBottom.vue": "./resources/icons/PopupButtonPositions/IconMiddleBottom.vue",
	"./PopupButtonPositions/IconMiddleTop.vue": "./resources/icons/PopupButtonPositions/IconMiddleTop.vue",
	"./PopupButtonPositions/IconRightBottom1.vue": "./resources/icons/PopupButtonPositions/IconRightBottom1.vue",
	"./PopupButtonPositions/IconRightBottom2.vue": "./resources/icons/PopupButtonPositions/IconRightBottom2.vue",
	"./PopupButtonPositions/IconRightBottom3.vue": "./resources/icons/PopupButtonPositions/IconRightBottom3.vue",
	"./PopupButtonPositions/IconRightMiddle.vue": "./resources/icons/PopupButtonPositions/IconRightMiddle.vue",
	"./PopupButtonPositions/IconRightTop1.vue": "./resources/icons/PopupButtonPositions/IconRightTop1.vue",
	"./PopupButtonPositions/IconRightTop2.vue": "./resources/icons/PopupButtonPositions/IconRightTop2.vue",
	"./PopupButtonPositions/IconRightTop3.vue": "./resources/icons/PopupButtonPositions/IconRightTop3.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/icons sync recursive \\.(js|vue)$/";